import { render, staticRenderFns } from "./WalletSettlementAccountBlacklist.vue?vue&type=template&id=98766caa&scoped=true"
import script from "./WalletSettlementAccountBlacklist.vue?vue&type=script&lang=js"
export * from "./WalletSettlementAccountBlacklist.vue?vue&type=script&lang=js"
import style0 from "./WalletSettlementAccountBlacklist.vue?vue&type=style&index=0&id=98766caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98766caa",
  null
  
)

export default component.exports